import { ColoredTextBoxContentModel } from 'src/api/models/ColoredTextBox';
import { setColor } from 'src/styles/colors';
import styled from 'styled-components';

const getBackgroundColor = (backgroundColor: ColoredTextBoxContentModel['backgroundColor']) => {
  if (backgroundColor === 'light green') return setColor('lightTeal');
  if (backgroundColor === 'sand') return setColor('wheat');
  if (backgroundColor === 'black') return setColor('text');
  return setColor(backgroundColor);
};

const getBackgroundTextColor = (backgroundColor: ColoredTextBoxContentModel['backgroundColor']) => {
  if (backgroundColor === 'black') return setColor('white');
  return setColor('text');
};

const getBackgroundLinkTextColor = (backgroundColor: ColoredTextBoxContentModel['backgroundColor']) => {
  if (backgroundColor === 'black') return setColor('lightTeal');
  return setColor('accentBlue');
};

export const ColoredTextBoxContainer = styled.div<{ backgroundColor: ColoredTextBoxContentModel['backgroundColor'] }>`
  padding: 3rem;
  margin: 2rem 0;
  border-radius: 1rem;
  background-color: ${({ backgroundColor }) => getBackgroundColor(backgroundColor)};
  color: ${({ backgroundColor }) => getBackgroundTextColor(backgroundColor)};

  h5.ast-h5-element {
    padding-top: 0;
  }

  p.ast-p-element {
    margin: 1rem 0em;
  }

  a.ast-a-element {
    color: ${({ backgroundColor }) => getBackgroundLinkTextColor(backgroundColor)} !important;
  }
`;
